import React, { useState, useEffect } from "react";

const ImageCarousel = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000); // Auto-advance every 5 seconds

    return () => clearInterval(timer);
  }, [images.length]);

  useEffect(() => {
    if (isModalOpen) {
      const handleKeyDown = (e) => {
        if (e.key === "Escape") {
          setIsModalOpen(false);
        } else if (e.key === "ArrowLeft") {
          setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? images.length - 1 : prevIndex - 1
          );
        } else if (e.key === "ArrowRight") {
          setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        }
      };
      document.addEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "hidden";
      return () => {
        document.removeEventListener("keydown", handleKeyDown);
        document.body.style.overflow = "unset";
      };
    }
  }, [isModalOpen, images.length]);

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleModalClick = (e) => {
    if (e.target.classList.contains("carousel-modal")) {
      closeModal();
    }
  };

  return (
    <>
      <div className="carousel-container">
        <div className="carousel-wrapper" onClick={openModal}>
          <button
            className="carousel-button carousel-button-prev"
            onClick={(e) => {
              e.stopPropagation();
              goToPrevious();
            }}
          >
            &#8249;
          </button>
          <div className="carousel-content" style={{ cursor: "pointer" }}>
            <img
              src={images[currentIndex]}
              alt={`Screenshot ${currentIndex + 1}`}
              className="carousel-image"
            />
          </div>
          <button
            className="carousel-button carousel-button-next"
            onClick={(e) => {
              e.stopPropagation();
              goToNext();
            }}
          >
            &#8250;
          </button>
        </div>
        <div className="carousel-indicators">
          {images.map((_, index) => (
            <button
              key={index}
              className={`carousel-indicator ${
                index === currentIndex ? "active" : ""
              }`}
              onClick={() => goToSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>

      {isModalOpen && (
        <div className="carousel-modal" onClick={handleModalClick}>
          <button className="carousel-modal-close" onClick={closeModal}>
            ×
          </button>
          <div className="carousel-modal-content">
            <button
              className="carousel-modal-button carousel-modal-button-prev"
              onClick={goToPrevious}
            >
              &#8249;
            </button>
            <img
              src={images[currentIndex]}
              alt={`Screenshot ${currentIndex + 1}`}
              className="carousel-modal-image"
            />
            <button
              className="carousel-modal-button carousel-modal-button-next"
              onClick={goToNext}
            >
              &#8250;
            </button>
          </div>
          <div className="carousel-modal-indicators">
            {images.map((_, index) => (
              <button
                key={index}
                className={`carousel-modal-indicator ${
                  index === currentIndex ? "active" : ""
                }`}
                onClick={() => goToSlide(index)}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default ImageCarousel;
